import Repository from '../Repository';

export default {

	assignUserRole(userId, roleId, qualificationId, languageId, subjectId) {
		var response = Repository.post('UserRole/AssignUserRole', {
			userId: userId,
			roleId: roleId,
			qualificationId: qualificationId,
			languageId: languageId,
			subjectId: subjectId
		});
		return response;
	},

	getUserRoles(userId) {
		var response = Repository.get('UserRole/GetUserRoles', {
			params: {
				userId: userId
			}
		});
		return response;
	},

	unassignUserRole(userId, userRoleId) {
		var response = Repository.put('UserRole/UnassignUserRole', {
			userId: userId,
			userRoleId: userRoleId
		});
		return response;
	},

}
